import {
  FormControl, IconButton, Input, InputAdornment, InputLabel, Box,
} from '@mui/material';
import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import toast from 'react-hot-toast';
import { api } from '../../api/api';

function SetPassword() {
  const params = useParams();
  const [password, setPassword] = useState('');
  const [type, setType] = useState(true);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [timeup, setTimeup] = useState(false);

  const submit = async () => {
    if (!password || password.length < 6) {
      toast.error('비밀번호는 6자 이상이어야 합니다.');
      return;
    }
    setLoading(true);
    try {
      const res = await api.patch(`/user/setpassword/${params.id}/${params.token}`, { newpassword: password });
      if (res.status === 200 && res.data.updatedPassword) {
        setDone(true);
        toast.success('비밀번호가 설정되었습니다. 로그인해 주세요.');
      } else if (res.data?.timeup) {
        setTimeup(true);
        toast.error('링크가 만료되었습니다. 관리자에게 문의하세요.');
      }
    } catch (err) {
      const data = err?.response?.data;
      if (data?.timeup) {
        setTimeup(true);
        toast.error('링크가 만료되었습니다. 관리자에게 문의하세요.');
      } else {
        toast.error(data?.message || '설정에 실패했습니다.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      {loading && (
        <Box sx={{
          position: 'absolute', height: '100vh', width: '100vw', background: 'rgba(0,0,0,0.5)',
          top: 0, left: 0, right: 0, bottom: 0, zIndex: 1000000,
          display: 'flex', justifyContent: 'center', alignItems: 'center',
        }}>
          <img src="/images/spiner.gif" alt="loading" />
        </Box>
      )}
      <div className="eclips-1" />
      <div className="eclips-2" />
      <div className="eclips-3" />
      <div className="inner-container">
        <div className="top-box">
          <div className="login-box">
            <div className="forget-password-form">
              <div className="login-form-header">
                <div className="logo-sec">
                  <div className="logo">
                    <img src="/images/LEEDOIT.png" alt="logo" />
                  </div>
                </div>
              </div>
              {done ? (
                <>
                  <div className="title">
                    <div className="login-icon" />
                    <div className="title-text">비밀번호가 설정되었습니다.</div>
                  </div>
                  <div className="other-controlls">
                    <Link to="/login">로그인</Link>
                  </div>
                </>
              ) : timeup ? (
                <>
                  <div className="title">
                    <div className="title-text">링크가 만료되었습니다.</div>
                  </div>
                  <div className="other-controlls">
                    <Link to="/login">로그인</Link>
                  </div>
                </>
              ) : (
                <>
                  <div className="login-form-body">
                    <div className="title">
                      <div className="login-icon" />
                      <div className="title-text">초기 비밀번호 설정</div>
                    </div>
                    <div className="input-fields">
                      <FormControl variant="standard" fullWidth>
                        <InputLabel htmlFor="setpassword">새 비밀번호 (6자 이상)</InputLabel>
                        <Input
                          id="setpassword"
                          type={type ? 'password' : 'text'}
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          endAdornment={
                            <InputAdornment position="end" style={{ marginTop: '-10px', color: '#551fff' }}>
                              <IconButton aria-label="toggle password" onClick={() => setType(!type)}>
                                {type ? <VisibilityOffIcon style={{ color: '#551fff' }} /> : <VisibilityIcon style={{ color: '#551fff' }} />}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                      </FormControl>
                    </div>
                    <div className="button-field">
                      <button type="button" className="btn-login" onClick={submit} disabled={loading}>
                        설정
                      </button>
                    </div>
                    <div className="resend-email flex justifyContentCenter alignItemCenter">
                      <Link to="/login">로그인으로 돌아가기</Link>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="text-box">
            <div className="text-block">
              <p className="main-heading">We Make Your Business Digitalize</p>
              <p className="sub-heading">문의: support@digntec.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SetPassword;
